import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';

export const useChangePasswordForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validate: {
      password: (value: string) => {
        if (value.length < 8)
          return t('forms.passwordTooShort', 'Le mot de passe doit contenir au moins 8 caractères');
        if (!/[A-Z]/.test(value))
          return t(
            'forms.passwordNeedsUppercase',
            'Le mot de passe doit contenir au moins une majuscule'
          );
        if (!/[a-z]/.test(value))
          return t(
            'forms.passwordNeedsLowercase',
            'Le mot de passe doit contenir au moins une minuscule'
          );
        if (!/[0-9]/.test(value))
          return t(
            'forms.passwordNeedsNumber',
            'Le mot de passe doit contenir au moins un chiffre'
          );
        return null;
      },
      confirmPassword: (value: string, values) =>
        value === values.password
          ? null
          : t('forms.passwordsDoNotMatch', 'Les mots de passe ne correspondent pas'),
    },
  });

  return { form };
};
